<!-- <h5 matDialogTitle *ngIf='options.title'>
    {{ options.title }}
</h5>

<mat-dialog-content class='dialog-container font-medium'>
    {{options.message}}
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close *ngFor='let button of options.buttons' (click)='execute(button.handler)'
        [ngClass]='button.class'>
        {{ button.text }}
    </button>
</mat-dialog-actions> -->

<div class="alert-container">
    <h5 matDialogTitle *ngIf='options.title' class="text-center">
        {{ options.title }}
    </h5>

    <div *ngIf="loading" class="display-flex-column flex-centered-container padding-bottom">
        <img *ngIf="terminated" src="../../../../assets/images/tick.svg">
        <mat-progress-spinner *ngIf="!terminated" [diameter]="50" [mode]="spinnerMode" [value]="value"
            color="accent"></mat-progress-spinner>
    </div>

    <div *ngIf="isPlanChangePopup" class="avatar flex-centered-container">
        <img src="/assets/icons/logo-compact.png">
    </div>

    <div class="confirmation-message" [innerHTML]="options.message">
    </div>

    <label *ngIf="options.checkbox" class="alert-checkbox">
        <input type="checkbox" [(ngModel)]="checkboxChecked">
        <span>{{ options.checkbox.label }}</span>
    </label>

    <div class="action-buttons">
        <div class="button-wrapper flex-centered-container-hr dialog-button" *ngFor='let button of options.buttons'>
            <button mat-flat-button class="ut-pro-button margin-top pad-4" [ngClass]="button.class"
                [color]="button.accent? 'accent': null" (click)="execute(button.handler)">
                {{ button.text }} 
            </button>
        </div>
    </div>
</div>